"use client";

import { useTranslation } from "react-i18next";

import { FooterCopyright } from "@/components/Footer/FooterCopyright";
import { Trustpilot } from "@/components/Trustpilot/Trustpilot";
import { Link } from "@/components/Link";
import { Logo } from "@/components/Logo";

import { paths } from "@/utils/paths";
import { getSiteInfo } from "@/sites";

export interface FooterLegalProps {
  hideTrustpilot?: boolean;
}

export const FooterLegal = ({ hideTrustpilot = false }: FooterLegalProps) => {
  const { t } = useTranslation("layout");

  const { siteBlackLogoFooter, siteName, showTrustpilot } =
    getSiteInfo(process.env.NEXT_PUBLIC_DOMAIN!) || {};

  return (
    <footer
      className="footer-legal"
      data-testid="footer-legal"
    >
      <div className="footer-legal__container">
        <div className="footer-legal__header">
          <Logo
            src={siteBlackLogoFooter}
            siteName={siteName}
            dataQa="footer-logo-link"
            dataTestId="footer-logo"
            width={280}
            height={49}
            loading="lazy"
          />

          {showTrustpilot && !hideTrustpilot && (
            <div className="trustpilot">
              <Trustpilot />
            </div>
          )}
        </div>

        <ul className="footer-legal__links">
          <li>
            <Link
              href={paths.termsAndConditions()}
              dataQA="footer-terms-and-conditions-button"
            >
              {t("footer_terms_and_conditions_text")}
            </Link>
          </li>
          <li>
            <Link
              href={paths.termsOfUse()}
              dataQA="footer-terms-of-use-button"
            >
              {t("footer_terms_of_use_text")}
            </Link>
          </li>
          <li>
            <Link
              href={paths.privacyPolicy()}
              dataQA="footer-privacy-policy-button"
            >
              {t("footer_privacy_policy_text")}
            </Link>
          </li>
          <li>
            <Link
              href={paths.cookiesPolicy()}
              dataQA="footer-cookies-policy-button"
            >
              {t("footer_cookies_policy_text")}
            </Link>
          </li>
        </ul>
      </div>

      <FooterCopyright />
    </footer>
  );
};
